import CityPageTemplate from "../city-template/CityPageTemplate";
import { brewerConfig } from "./data";

export default function BrewerPage() {
  return <CityPageTemplate config={brewerConfig} />;
}